// can be replaced someday (maybe in PS 0.13?) with
// const {storage} = require('local-storage-fallback')
import {storage} from "local-storage-fallback";

// getItem :: String -> Effect (Nullable String)
export function getItem(key) {
  return function () {
    return storage.getItem(key);
  };
}

// setItem :: String -> String -> Effect Unit
export function setItem(key) {
  return function (value) {
    return function () {
      storage.setItem(key, value);
    };
  };
}
